export * from '~/Api/Authentication/AccessToken';
export * from '~/Api/Authentication/PasswordLogin';
export * from '~/Api/Authentication/PasswordReset';
export * from '~/Api/Authentication/PasswordSetup';
export * from '~/Api/Authentication/RequestPasswordReset';
export var PasswordMinLength = 8;
export var PasswordMaxByteSize = 72;
export var isPasswordTooBig = function (password) { return new Blob([password]).size > PasswordMaxByteSize; };
